import { render } from "./AndroidAppsPopup.vue?vue&type=template&id=57dc359a&ts=true"
import script from "./AndroidAppsPopup.vue?vue&type=script&lang=ts"
export * from "./AndroidAppsPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__